import * as React from "react";
import { type FC } from "react";
import { Gapped, Select } from "react-ui";

import { Caption, Row } from "../../FiasFnsManualEditor.styles";
import { getMunicipalDistrictItems } from "../FiasFnsManualEditorUtils";
import { Control } from "../controlsPaths";
import { AddressField } from "../AddressField";

interface DistrictProps {
    withFederalTerritory?: boolean;
    getValue: (control: Control) => string;
    onChange: (control: Control) => (next: string) => void;
}

const controlType = Control.DistrictType;
const controlName = Control.DistrictName;

export const District: FC<DistrictProps> = props => {
    const type = props.getValue(controlType);
    const municipalDistrictItems = getMunicipalDistrictItems(type, props.withFederalTerritory);
    const name = props.getValue(controlName);
    const onTypeChange = props.onChange(controlType);
    const onNameChange = props.onChange(controlName);

    return (
        <Row>
            <Caption>Муниципальный район / округ</Caption>
            <Gapped>
                <Select<string | undefined, string>
                    width={80}
                    placeholder={"Вид"}
                    data-tid={"DistrictType"}
                    value={type || undefined}
                    // @ts-expect-error Нужно сетить undefined для отображения placeholder-a
                    onValueChange={next => onTypeChange(next || undefined)}
                    items={municipalDistrictItems}
                />

                <AddressField
                    width={260}
                    maxLength={255}
                    value={name}
                    placeholder={"Наименование"}
                    data-tid={"DistrictName"}
                    onChange={onNameChange}
                />
            </Gapped>
        </Row>
    );
};
